import {Injector, NgModule} from '@angular/core';
import { ContentTabsComponentGeneric } from './content-tabs.component';
import {MatTabsModule} from '@angular/material/tabs';
import {createCustomElement} from "@angular/elements";
import { DecodeBase64PipeModule, SafePipeModule, ReplaceTokensPipeArrayModule} from '@signature-it/ngx-generic/pipes';
import {CommonModule} from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
        SafePipeModule,
        MatTabsModule,
        DecodeBase64PipeModule,
        ReplaceTokensPipeArrayModule
    ],
    declarations: [ContentTabsComponentGeneric],
    exports: [ContentTabsComponentGeneric]
})
export class ContentTabsModuleGeneric {
    constructor(private injector: Injector) {
        const contentTabs = createCustomElement(ContentTabsComponentGeneric, {injector});
        !customElements.get('ngx-content-tabs') && customElements.define('ngx-content-tabs', contentTabs);
    }
}
